<template>
    <div class="tableItem">
        <div class="nav">
            <div>
                <span :style="{background:type=='home'? '#E05C5C' : '#3699FF'}"></span>
                <span>{{title}}</span>
            </div>
            <div>
                {{team}}
            </div>
        </div>
        <div class="table" v-if="falg != 'shang'">
            <div class="tab thead">
                <div>
                    <span class="name">姓名</span>
                    <span>出场次数</span>
                    <span>进球</span>
                    <span>助攻</span>
                    <span>黄牌</span>
                    <span>红牌</span>
                    <span>位置</span>
                </div>
            </div>
            <div class="tab tbody" v-if="data.length > 0">
                <div class="item" v-for="item,index in data" :key="index">
                    <span class="name">
                        <em  :class="{img_bule:type != 'home'}">{{item.shirt_number}}</em>
                        <p>{{item.player_name}}</p>
                    </span>
                    <span>{{item.total_num || '-'}}</span>
                    <span>{{item.goal_num || '-'}}</span>
                    <span>{{item.assists_num || '-'}}</span>
                    <span>{{item.yellow_num || '-'}}</span>
                    <span>{{item.red_num || '-'}}</span>
                    <span>{{item.position_name || '-'}}</span>
                </div>
            </div>
            <div v-else class="kong">
                暂无人员
            </div>
        </div>
        <div class="table" v-else>
            <div class="tab thead">
                <div>
                    <span class="name">姓名</span>
                    <span style="flex:none;width:130px">位置</span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span style="flex:none;width:180px">伤停原因</span>
                    <span></span>
                </div>
            </div>
            <div class="tab tbody" v-if="data.length > 0" >
                <div class="item" v-for="item,index in data" :key="index">
                    <span class="name">
                        <em  :class="{img_bule:type != 'home'}">{{item.shirt_number}}</em>
                        <p>{{item.player_name}}</p>
                    </span>
                    <span style="flex:none;width:130px">{{item.position || '-'}}</span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span style="flex:none;width:180px">{{item.reason || '-'}}</span>
                    <span></span>
                </div>
            </div>
            <div v-else class="kong">
                暂无人员
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "tbaleItem",
    props: ["title","type","data","falg","team"]
}
</script>

<style lang="less" scoped>
.tableItem{
    width: 45px;
        background: #FFFFFF;
    .kong{
        width: 450px !important;
        height: 50px;
        background: #FFFFFF;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 50px;
        border:1px #EAE9F2 solid ;
        border-top: none ;
    }
    .nav{
        width: 450px;
        height: 54px;
        background: #FFFFFF;
        line-height: 54px;
        display: flex;
        justify-content: space-between;
        div{
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #494A54;
            &:first-child{
                display: flex;
                align-items: center;
                span{
                    &:first-child{
                        width: 10px;
                        height: 10px;
                        background: #E05C5C;
                        margin-right:10px ;
                    }
                }
            }
            &:last-child{
                margin-right:12px ;
            }
        }
       
    }
    .table{
        text-align: center;
        .tab{
            div{
                display: flex;
                height: 40px;
                width: 450px;
                background: #EEEFF2;
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #848A9C;
                line-height: 40px;
                border-bottom:1px solid #EAE9F2;
                border-left: 1px solid #EAE9F2;
                border-right: 1px solid #EAE9F2;
                span{
                    flex: 1;
                }
                .name{
                    width: 130px;
                    flex: none;
                    text-align: left;
                    margin-left: 18px;
                } 
            }
        }
        .tbody{
            .item{
                &:hover{
                    background: #F6F6F8 !important;
                    div{
                        background: #F6F6F8 !important;
                    }
                }
            }
            div{
                height: 46px;
                background: #fff;
                color: #333;
                line-height: 46px;
                
                .name{
                    display: flex;
                    align-items: center;
                    margin-left:15px ;
                    p{
                         overflow: hidden;
                         text-overflow:ellipsis;
                         white-space: nowrap;
                         flex: 1;
                         height: 46px;
                         border-left: none;
                         border-right:none ;
                    }
                    em{
                        width: 32px;
                        height: 34px;
                        background: url("../../../assets/img/matchDetails/lineup_team_home.png") ;
                        background-size:100% 100% ;
                        text-align: center;
                        font-style: normal;
                        font-size: 12px;
                        font-family: Source Han Sans CN;
                        // font-weight: bold;
                        color: #FFFFFF;
                        line-height: 34px;
                        margin-right:10px ;
                    }
                    .img_bule{
                        background: url("../../../assets/img/matchDetails/lineup_team_away.png") ;
                        background-size:100% 100% ;
                    }
                }
            }
        }
    }
    .item2{
        .tab{
            .name{
                width: 170px !important;
            }
        }
        .tbody{
            min-height: 300px;
            div{
                height: 50px;
                line-height: 50px;
                .name{
                    // em{
                    //     width: 32px;
                    //     height: 32px;
                    //     border-radius: 50% !important;
                    //     background: red;
                    //     background-size:100% 100% ;
                    //     margin-right:10px ;
                    // }
                    div{
                        flex: 1;
                        border: none;
                        display: flex;
                        flex-direction: column;

                       p{
                            font-size: 12px;
                            height: 25px;
                            line-height: 25px;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            color: #333333;
                        //    &:last-child{
                        //        color: #848A9C;
                        //        display: flex;
                        //        justify-content: flex-end;
                        //        align-items: flex-end;
                        //        margin-top:-5px ;
                        //     //    span{
                        //     //        &:first-child{
                        //     //            flex: none;
                        //     //            width: 25px;
                        //     //            margin-right: 9px;
                        //     //        }
                        //     //    }
                        //    }
                       }
                    }
                }
            }
           
        }
    }
}
</style>